'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CheckCircle from '@mui/icons-material/CheckCircle';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import Error from '@mui/icons-material/Error';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import Info from '@mui/icons-material/Info';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Warning from '@mui/icons-material/Warning';
import WarningAmber from '@mui/icons-material/WarningAmber';
import MuiAlert from '@mui/material/Alert';
import { useMemo } from 'react';
import Typography from './Typography';
export default function Alert({ title, subTitle, variant, ...props }) {
    const iconMapping = useMemo(() => {
        switch (variant) {
            case 'filled':
                return {
                    error: _jsx(Error, {}),
                    warning: _jsx(Warning, {}),
                    info: _jsx(Info, {}),
                    success: _jsx(CheckCircle, {}),
                };
            case 'outlined':
                return {
                    error: _jsx(ErrorOutline, {}),
                    warning: _jsx(WarningAmber, {}),
                    info: _jsx(InfoOutlined, {}),
                    success: _jsx(CheckCircleOutline, {}),
                };
            case 'standard':
                return {
                    error: _jsx(ErrorOutline, {}),
                    warning: _jsx(WarningAmber, {}),
                    info: _jsx(InfoOutlined, {}),
                    success: _jsx(CheckCircleOutline, {}),
                };
            default:
                return undefined;
        }
    }, [variant]);
    return (_jsxs(MuiAlert, { variant: variant, iconMapping: iconMapping, ...props, children: [_jsx(Typography, { fontSize: 16, fontWeight: 500, lineHeight: "22.4px", children: title }), _jsx(Typography, { fontSize: 14, fontWeight: 500, lineHeight: "19.6px", children: subTitle })] }));
}
